import React from "react";
import { Link } from "react-router-dom";

const TeamProjects = () => {
  return (
    <div className="popular-projects">
      <div className="popular-project-head-div">
        <div data-aos="zoom-out" className="row  com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/pvbcQs7/Screenshot-198.png"
              alt="home page"
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">
              Service A2Z (TeamLeader of this project)
            </h3>
            <div data-aos="slide-up">
              <p>
                It’s a Team project, our team's name is Team Binary, 5 another
                teammates were working with me, we make this site within 2
                month's.
              </p>
              <p>
                Service A2Z is a multi vendor based service platform site, we
                were following Sheba.xyz
              </p>
              <p>
                Uses Technologies are React, Redux-Toolkit, Socket.io, NodeJs,
                MongoDB, Express, Firebase Authentication, Material UI,
                Nodemailer, Stripe Payment etc.
              </p>
              <p>We have 4 types of users. 1:Normal-visitor, 2:LoggedIn-user, 3:Our-providers, 4:Admin</p>
            </div>
            <Link className="aboutMe-button" to="/ServiceA2Z">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://service-assistant-a2z.web.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamProjects;
